export const FEEDBACK_COLLECTOR_ENTRYPOINT_ID = '45c9c029-3180-4960-ab0d-db7cdeaf5f54';
export const MS_IN_SECOND = 1000;
export const SECONDS_IN_MIN = 60;
/* eslint-disable-next-line @atlaskit/platform/one-value-export-per-file -- computed constant, not worth its own file */
export const SECONDS_IN_HR: number = SECONDS_IN_MIN * 60;
export const LS_PROVIDER_KEY = 'aiMateSmartLinkProviders';
export const AI_MATE_EXPERIENCE_ID = 'ai-mate';
export const DIRECTORY_URL = '/gateway/api/directory/graphql';
/** 30 minutes in milliseconds */
// eslint-disable-next-line @atlaskit/platform/one-value-export-per-file
export const TIMEOUT_BEFORE_NEW_CHAT: number = 30 * SECONDS_IN_MIN * MS_IN_SECOND;
/** 5 minutes in milliseconds */
// eslint-disable-next-line @atlaskit/platform/one-value-export-per-file
export const SHORTER_TIMEOUT_BEFORE_NEW_CHAT: number = 5 * SECONDS_IN_MIN * MS_IN_SECOND;
export const LS_LAST_MESSAGE_SENT_AT = 'rovoChatLastMessageSentAt';

/**
 * Height of the greeting header in mini modal (in pixels).
 * Used to adjust minimum height calculation so users can resize below
 * the initial height when greeting is visible.
 */
export const MINI_MODAL_GREETING_HEIGHT = 140;

/**
 * Expanded max height cap for the mini modal (Rovo chat) when not limited by the viewport.
 */
export const MINI_MODAL_EXPANDED_HEIGHT = '600px';

/**
 * Default initial width (in pixels) of the right panel in the conversation
 * assistant split layout. Used when no persisted width is available.
 */
export const SPLIT_LAYOUT_INITIAL_WIDTH = 380;

/**
 * Minimum width (in pixels) for the main (left) panel of the conversation
 * assistant split layout. The right panel cannot be resized to leave the
 * left panel narrower than this.
 */
export const SPLIT_LAYOUT_MIN_WIDTH = 480;

/**
 * Minimum width (in pixels) for the right (adjacent) panel of the conversation
 * assistant split layout. The right panel cannot be resized below this.
 */
export const SPLIT_LAYOUT_ADJACENT_MIN_WIDTH = 280;

/**
 * Minimum width (in pixels) the enclosing panel must have for the split layout
 * to be usable.
 */
export const SPLIT_LAYOUT_MIN_PANEL_WIDTH = 760;
